import { render } from "./HeroiconsSolidLockClosed.vue?vue&type=template&id=9ae7e13a"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLockClosed.vue"]])

export default __exports__